<template>
  <div>
    <div class="newsMain" v-if="getLocaltypes()==1">
      <div class="Contentframe" >
          <div class="leftmenu">              
                    
            <LeftMenus  :styles="styles" :active="active" :infoID="$route.query.infoID"></LeftMenus>
      </div>
   
    <div class="rightContent"> 
       <iframe :src="imagepath+htmlURLs" id="outerHTML" width='100%'  name="ifd"  ref="iframe2"   style="min-height:800px" scrolling="no" frameborder="0"  ></iframe> 
       </div>
    </div>
  </div>


  
  <div v-if="getLocaltypes()==2">
    <div class="rightContent"> 
       <iframe :src="imagepath+htmlURLs" id="outerHTML2" width='100%'  name="ifd"  ref="iframe2"   style="min-height:800px" scrolling="no" frameborder="0"  ></iframe> 
       </div>
</div>
    </div>
  </template>
  
  <script>
import LeftMenus from './../../LeftMenus.vue'
import {getLocaltype} from '../../../mainConfig/thu'
 export default {
  components:{LeftMenus},
    mounted(){
  
        var that = this
      const iframe = document.querySelector('#outerHTML')
      
      // 处理兼容行问题
      if (iframe.attachEvent) {
        iframe.attachEvent('onload', function () {
          // iframe加载完毕以后执行操作
        })
      } else {
        iframe.onload = function () {
          // iframe加载完毕以后执行操作iframe
          console.log('hhhiframe已加载完毕')
          iframe.style.height =
           that.$refs.iframe2.contentWindow.document.body.scrollHeight + 'px';
           console.log(iframe.style.height)
           let phoneWidth= document.documentElement.clientWidth
       let htmlWidth= that.$refs.iframe2.contentWindow.document.body.scrollWidth
       let zoomW=phoneWidth/htmlWidth
          iframe.style.width  = '100%'
          if(that.getLocaltypes()==2){
            iframe.style.zoom=zoomW
          }
  
        }
        
      }
  
    },
    //  components:{LeftNavigation},
  data(){
    return{
      htmlURLs:'',
      imagepath:'',
      visible: true,
      infoList:[],
      info:{},
      active:[],
      styles:[],
    }
  },
  created(){
    this.getHtmlpath() 
    //  this.reinitframe();
    
  },
  methods:{
    getLocaltypes(){
  return getLocaltype();
},
    getHtmlpath(){
      this.imagepath=this.$imagepath
      this.active=this.$route.query.active
       this.styles=this.$route.query.styles
      this.htmlURLs=this.$route.query.htmlpath
      //   this.axios.post("/info/getInfo?infoID="+this.$route.query.infoID)
      // .then(resp => { 
      //                   if(resp.data.status == 1) {      
      //                     this.info=resp.data.result[0]                                                
      //                                console.log(resp.data.result[0])           
      //                             }else {
      //                                alert("拿取数据失败")                                 
      //                             }
      //                         })
      //                         .catch((err) => {
      //                            // alert("出错了")
      //                             console.log(err)
      //                         })     

    this.axios.post("/info/getInfo?infoID="+this.$route.query.infoID)
    .then(resp => { 
                      if(resp.data.status == 1) {      
                        this.info=resp.data.result[0]                                                
                                   console.log(resp.data.result[0])   
                                   this.infoList=resp.data.result[0]   
                                }else {
                                   alert("拿取数据失败")                                 
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            })     
    
    },
    
  selected(name){
     this.active = name;
  },
  
  reinitframe()
  {
    var  iframe= window.document.getElementById("outerHTML");
    console.log('ggg');
    console.log(iframe)
    
          iframe.onload = function()
      
          {
        
            iframe.style.height = 
            iframe.contentWindow.document.body.scrollHeight + 'px';
             
    
           // set the width of the iframe as the 
           // width of the iframe content
           iframe.style.width  = 
            iframe.contentWindow.document.body.scrollWidth+'px';
                
          }
  
           console.log(iframe.style.width)
  
  }
  
  
  } 
  } 
  </script>
  
  <style scoped>
    .leftAside{
      position: fixed;
      width:30%;
     
    }
  #outerHTML{
    padding-left: 60px;
    width: 100%;
    padding-top: 20px;
  
    
  }
  #outerHTML2{
    width: 100%;
    padding-top: 20px;
  
    
  }
  .newsMain{
    width: 100%;
    height: 100%;
        display: block;
    
  }
  .Contentframe{
    width: 90%;
    margin: auto;
    display: flex;
   

  }
  
  .active {
      
      border-bottom: 4px solid #0065bd;
      /* border-left: 2px solid #e362d5;
      border-color: transparent transparent transparent #E362D5; */
      
   }
  
   .leftmenu
   {
     padding-left:15px;
       background:#0065bd;
     color:black;
     margin-top: 40px;
     margin-right: 20px;
     height:500px;
     width:20%;
     padding: 20px;
     box-shadow: 0px 0px 2px #ededed;
   }
  
   .firstmenu
   {
     font-weight: 500;
     font-size: 18px;
     line-height: 20px;
     padding-top: 10px;
      border-left: 8px solid #ffd04b;
      /* border-bottom: 1px solid #ecebeb; */
     
   }
  
   .firstsubMenu
   {
     width: 100%;
      height: 40px;
      line-height: 40px;
      color: #010544;
      padding: 0 10px;
      font-size: 18px;
      font-weight: 600;
      border-left: 6px solid #0065bd;
      /* border-bottom: 1px solid #ecebeb; */
  }
   .firstsubMenu1
   {
     width: 100%;
      height: 0.52rem;
      line-height: 0.52rem;
      color: #010544;
      padding: 0 10px;
      font-size: 0.2rem;
      font-weight: 600;
      border-left: 0.08rem solid #e362d5;
      border-bottom: 1px solid #ecebeb;
  }
   
  
    .submenu
   {
     font-weight: 400;
     font-size: 16px;
      margin-left: 10px;
      color: black;
      /* border-bottom: 2px solid #ecebeb */
     
   }
  .rightContent{
    width: 80%;
    margin-left:50px;
  
  }
  
  .el-container{
    height: auto;
  }
  
  
  
   .el-aside .leftmenu{
    position: fixed;
  
   }
    .router-link-active {     
     text-decoration: none;
     
   }
   
   a {
     text-decoration: none;
  
   }
  </style>


// WEBPACK FOOTER //
// src/components/work/navigation/majorsetup/FourCommunication.vue